import { render } from "./NewsDetailsView.vue?vue&type=template&id=14374ee8&scoped=true"
import script from "./NewsDetailsView.vue?vue&type=script&lang=js"
export * from "./NewsDetailsView.vue?vue&type=script&lang=js"

import "./NewsDetailsView.vue?vue&type=style&index=0&id=14374ee8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14374ee8"]])

export default __exports__